import api from '../../api/api';
export const NOTICE_PAGE_SIZE = 20;
export function noticeTab(params) {
  return params.get('category') === 'notice' || (!params.has('category') && params.has('page'))
    ? 'notice'
    : 'event';
}
export function noticePage(params) {
  const page = Number(params.get('page'));
  return Number.isSafeInteger(page) && page > 0 ? page : 1;
}
export function uniqueNotices(items) {
  const seen = new Set();
  return items.filter((item) => {
    if (!item || item.id == null || item.isHidden || seen.has(String(item.id))) return false;
    seen.add(String(item.id));
    return true;
  });
}
export async function loadNotices(page, locale, signal) {
  const config = { signal, suppressGlobalError: true, timeout: 15000 };
  const [pinned, result] = await Promise.all([
    page === 1
      ? api.getPublic('/notices/pinned', { ...config, params: { locale } })
      : Promise.resolve({ data: { data: [] } }),
    api.getPublic('/notices', { ...config, params: { page, size: NOTICE_PAGE_SIZE, locale } }),
  ]);
  if (!Array.isArray(pinned.data?.data) || !Array.isArray(result.data?.data))
    throw new Error('Invalid notice response');
  const pagination = result.data.meta?.pagination;
  const current = Number(pagination?.currentPage ?? page);
  const total = Number(pagination?.totalPages ?? page);
  return {
    items: uniqueNotices([...pinned.data.data, ...result.data.data]),
    next: current === page && Number.isSafeInteger(total) && total > page ? page + 1 : undefined,
  };
}
export function noticeDate(value, locale) {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? String(value)
    : new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(date);
}
export function eventHref(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname && !url.username && !url.password
      ? url.href
      : null;
  } catch {
    return null;
  }
}
